import { BulkAuthenticationSettingKey } from '../../services/identity/AuthenticationSettingService';
import { useCheckAuthenticationSetting } from './useCheckAuthenticationSetting';

export const useCheckSSOEnabled = () => {
    const bulkAuthenticationSetting = useCheckAuthenticationSetting();
    return bulkAuthenticationSetting?.[BulkAuthenticationSettingKey.AAD] || bulkAuthenticationSetting?.[BulkAuthenticationSettingKey.SAML];
};
